import React from "react";
import { useTranslation } from "react-i18next";
import { getAppointmentObject } from "../../../../features/appointments/utils/BookingFunctions";
import useUser from "../../../../hooks/useUser";

export default function useGetAppointmentObject() {
  const { profile, roles, currentClinic } = useUser();
  const isBasicTier = currentClinic.basicTier;
  function getObject(data) {
    return getAppointmentObject(data, roles.adminOrEmployee, profile.email, isBasicTier);
  }
  return { getObject };
}
